import api from '../utils/Api';

/**
 * 🔹 Obtener todos los casilleros (solo admin/superadmin)
 */
export const getAllCasilleros = async () => {
  try {
    const res = await api.get('/casilleros/all'); // 👈 sin /api porque baseURL ya lo incluye
    return res.casilleros
      ? { success: true, casilleros: res.casilleros, total: res.total }
      : { success: false, mensaje: 'No se encontraron casilleros' };
  } catch (err) {
    console.error('[casillerosService] ❌ Error al obtener todos los casilleros:', err.message);
    return { success: false, mensaje: 'Error al obtener casilleros', detalle: err.message };
  }
};

/**
 * 🔹 Obtener el casillero del cliente autenticado
 */
export const getMiCasillero = async () => {
  try {
    const res = await api.get('/casilleros/mi-casillero'); // 👈 igual, sin /api
    return res.casillero
      ? { success: true, casillero: res.casillero }
      : { success: false, mensaje: 'No tienes casillero asignado' };
  } catch (err) {
    console.error('[casillerosService] ❌ Error al obtener mi casillero:', err.message);
    return { success: false, mensaje: 'Error al obtener tu casillero', detalle: err.message };
  }
};